{
  "$id": "wealthlane://forms/espp/rules",
  "effects": [
    {
      "id": "lookbackDescriptionTrue",
      "watch": "#/properties/lookback",
      "condition": {
        "field": "#/properties/lookback",
        "equals": true
      },
      "set": {
        "#/properties/description": {
          "operator": "value",
          "value": "Lower of price at Offering start or price at Purchase."
        }
      }
    },
    {
      "id": "lookbackDescriptionFalse",
      "watch": "#/properties/lookback",
      "runOnMount": true,
      "condition": {
        "field": "#/properties/lookback",
        "notEquals": true
      },
      "set": {
        "#/properties/description": {
          "operator": "value",
          "value": "Purchase price is equal to FMV at Purchase."
        }
      }
    },
    {
      "id": "seedFirstPurchasePeriod",
      "watch": ["#/properties/offeringPeriodStartDate", "#/properties/offeringPeriodEndDate"],
      "appendIfEmpty": {
        "field": "#/properties/purchasePeriods",
        "value": {},
        "template": {
          "periodStartDate": { "operator": "field", "name": "offeringPeriodStartDate" },
          "periodEndDate": { "operator": "field", "name": "offeringPeriodEndDate" },
          "purchaseDate": { "operator": "field", "name": "offeringPeriodEndDate" }
        }
      }
    },
    {
      "id": "clearNextOfferingPeriodWhenRolloverOff",
      "watch": "#/properties/rolloverEnrollment",
      "condition": {
        "field": "#/properties/rolloverEnrollment",
        "notEquals": true
      },
      "clear": [
        "#/properties/nextOfferingPeriodId",
        "#/properties/residualCashDisposition"
      ]
    }
  ],
  "arrayRules": {
    "purchasePeriods": {
      "resetVisibleWhen": { "field": "purchasePeriods.length", "equals": 1 },
      "resetWhen": {
        "allOf": [
          { "field": "offeringPeriodStartDate", "notEmpty": true },
          { "field": "offeringPeriodEndDate", "notEmpty": true }
        ]
      },
      "resetDefaults": {
        "periodStartDate": { "operator": "field", "name": "^offeringPeriodStartDate" },
        "periodEndDate": { "operator": "field", "name": "^offeringPeriodEndDate" },
        "purchaseDate": { "operator": "field", "name": "^offeringPeriodEndDate" },
        "enrollmentWindowStartDate": {
          "operator": "ifElse",
          "condition": { "field": "^enrollStartDaysPriorToPurchasePeriod", "gt": 0 },
          "then": {
            "operator": "pipe",
            "steps": [
              { "operator": "field", "name": "^offeringPeriodStartDate" },
              { "operator": "dateOffset", "days": "^enrollStartDaysPriorToPurchasePeriod", "negate": true }
            ]
          },
          "else": { "operator": "value", "value": "" }
        },
        "enrollmentWindowEndDate": {
          "operator": "ifElse",
          "condition": {
            "allOf": [
              { "field": "^enrollStartDaysPriorToPurchasePeriod", "gt": 0 },
              { "field": "^enrollDays", "gt": 0 }
            ]
          },
          "then": {
            "operator": "pipe",
            "steps": [
              { "operator": "field", "name": "^offeringPeriodStartDate" },
              { "operator": "dateOffset", "days": "^enrollStartDaysPriorToPurchasePeriod", "negate": true },
              { "operator": "dateOffset", "days": "^enrollDays" }
            ]
          },
          "else": { "operator": "value", "value": "" }
        },
        "changeWindowStartDate": { "operator": "field", "name": "^offeringPeriodStartDate" },
        "changeWindowEndDate": {
          "operator": "ifElse",
          "condition": { "field": "^changeEndDaysPriorToPurchaseDate", "gt": 0 },
          "then": {
            "operator": "pipe",
            "steps": [
              { "operator": "field", "name": "^offeringPeriodEndDate" },
              { "operator": "dateOffset", "days": "^changeEndDaysPriorToPurchaseDate", "negate": true }
            ]
          },
          "else": { "operator": "value", "value": "" }
        }
      },
      "arrayEffects": [
        {
          "id": "offeringDatesChanged",
          "watch": ["offeringPeriodStartDate", "offeringPeriodEndDate"],
          "condition": { "anyOf": [
            { "field": "offeringPeriodStartDate", "changed": true },
            { "field": "offeringPeriodEndDate", "changed": true }
          ]},
          "perRow": {
            "periodStartDate": { "operator": "field", "name": "offeringPeriodStartDate" },
            "periodEndDate": { "operator": "field", "name": "offeringPeriodEndDate" },
            "purchaseDate": { "operator": "field", "name": "offeringPeriodEndDate" }
          },
          "preserveUserEdits": true
        },
        {
          "id": "enrollmentWindowDatesOnRulesChanged",
          "watch": [
            "enrollStartDaysPriorToPurchasePeriod",
            "enrollDays",
            "enrollmentWindowMaxChanges",
            "changeWindowMaxUpChanges",
            "changeWindowMaxDownChanges"
          ],
          "condition": { "anyOf": [
            { "field": "enrollStartDaysPriorToPurchasePeriod", "changed": true },
            { "field": "enrollDays", "changed": true },
            { "field": "enrollmentWindowMaxChanges", "changed": true },
            { "field": "changeWindowMaxUpChanges", "changed": true },
            { "field": "changeWindowMaxDownChanges", "changed": true }
          ]},
          "perRow": {
            "enrollmentWindowStartDate": {
              "operator": "ifElse",
              "condition": {
                "allOf": [
                  { "field": "enrollStartDaysPriorToPurchasePeriod", "notEmpty": true },
                  { "field": "purchasePeriods.{i}.periodStartDate", "notEmpty": true }
                ]
              },
              "then": {
                "operator": "pipe",
                "steps": [
                  { "operator": "field", "name": "purchasePeriods.{i}.periodStartDate" },
                  { "operator": "dateOffset", "days": "enrollStartDaysPriorToPurchasePeriod", "negate": true }
                ]
              },
              "else": { "operator": "value", "value": "" }
            },
            "enrollmentWindowEndDate": {
              "operator": "ifElse",
              "condition": {
                "allOf": [
                  { "field": "enrollStartDaysPriorToPurchasePeriod", "notEmpty": true },
                  { "field": "enrollDays", "notEmpty": true },
                  { "field": "purchasePeriods.{i}.periodStartDate", "notEmpty": true }
                ]
              },
              "then": {
                "operator": "pipe",
                "steps": [
                  { "operator": "field", "name": "purchasePeriods.{i}.periodStartDate" },
                  { "operator": "dateOffset", "days": "enrollStartDaysPriorToPurchasePeriod", "negate": true },
                  { "operator": "dateOffset", "days": "enrollDays" }
                ]
              },
              "else": { "operator": "value", "value": "" }
            }
          },
          "preserveUserEdits": false
        },
        {
          "id": "clearEnrollmentEndWhenNoEnrollDays",
          "watch": ["enrollDays"],
          "condition": {
            "allOf": [
              { "field": "enrollDays", "changed": true },
              { "field": "enrollDays", "isEmpty": true }
            ]
          },
          "perRow": {
            "enrollmentWindowEndDate": { "operator": "value", "value": "" }
          },
          "preserveUserEdits": false
        },
        {
          "id": "clearEnrollmentEndWhenNoEnrollStartPrior",
          "watch": ["enrollStartDaysPriorToPurchasePeriod"],
          "condition": {
            "allOf": [
              { "field": "enrollStartDaysPriorToPurchasePeriod", "changed": true },
              { "field": "enrollStartDaysPriorToPurchasePeriod", "isEmpty": true }
            ]
          },
          "perRow": {
            "enrollmentWindowEndDate": { "operator": "value", "value": "" }
          },
          "preserveUserEdits": false
        },
        {
          "id": "changeEndDateRuleChanged",
          "watch": ["changeEndDaysPriorToPurchaseDate"],
          "condition": {
            "allOf": [
              { "field": "changeEndDaysPriorToPurchaseDate", "notEmpty": true },
              { "field": "changeEndDaysPriorToPurchaseDate", "changed": true }
            ]
          },
          "perRow": {
            "changeWindowEndDate": {
              "operator": "ifElse",
              "condition": {
                "allOf": [
                  { "field": "changeEndDaysPriorToPurchaseDate", "notEmpty": true },
                  { "anyOf": [
                    { "field": "purchasePeriods.{i}.purchaseDate", "notEmpty": true },
                    { "field": "purchasePeriods.{i}.periodEndDate", "notEmpty": true }
                  ]}
                ]
              },
              "then": {
                "operator": "pipe",
                "steps": [
                  {
                    "operator": "coalesce",
                    "fields": [
                      "purchasePeriods.{i}.purchaseDate",
                      "purchasePeriods.{i}.periodEndDate"
                    ]
                  },
                  { "operator": "dateOffset", "days": "changeEndDaysPriorToPurchaseDate", "negate": true }
                ]
              },
              "else": { "operator": "value", "value": "" }
            }
          },
          "preserveUserEdits": false
        },
        {
          "id": "clearChangeEndWhenNoDaysPrior",
          "watch": ["changeEndDaysPriorToPurchaseDate"],
          "condition": {
            "allOf": [
              { "field": "changeEndDaysPriorToPurchaseDate", "changed": true },
              { "field": "changeEndDaysPriorToPurchaseDate", "isEmpty": true }
            ]
          },
          "perRow": {
            "changeWindowEndDate": { "operator": "value", "value": "" }
          },
          "preserveUserEdits": false
        }
      ],
      "itemRowObservers": [
        {
          "watch": "periodEndDate",
          "target": "purchaseDate",
          "compute": { "operator": "field", "name": "periodEndDate" },
          "onlyIfDerived": false
        },
        {
          "watch": "periodStartDate",
          "target": "enrollmentWindowStartDate",
          "compute": {
            "operator": "ifElse",
            "condition": {
              "allOf": [
                { "field": "^enrollStartDaysPriorToPurchasePeriod", "notEmpty": true },
                { "field": "periodStartDate", "notEmpty": true }
              ]
            },
            "then": {
              "operator": "pipe",
              "steps": [
                { "operator": "dateOffset", "days": "^enrollStartDaysPriorToPurchasePeriod", "negate": true }
              ]
            },
            "else": { "operator": "field", "name": "enrollmentWindowStartDate" }
          },
          "onlyIfDerived": true
        },
        {
          "watch": "periodStartDate",
          "target": "enrollmentWindowEndDate",
          "compute": {
            "operator": "ifElse",
            "condition": {
              "allOf": [
                { "field": "^enrollStartDaysPriorToPurchasePeriod", "notEmpty": true },
                { "field": "^enrollDays", "notEmpty": true },
                { "field": "periodStartDate", "notEmpty": true }
              ]
            },
            "then": {
              "operator": "pipe",
              "steps": [
                { "operator": "dateOffset", "days": "^enrollStartDaysPriorToPurchasePeriod", "negate": true },
                { "operator": "dateOffset", "days": "^enrollDays" }
              ]
            },
            "else": { "operator": "field", "name": "enrollmentWindowEndDate" }
          },
          "onlyIfDerived": true
        },
        {
          "watch": "purchaseDate",
          "target": "changeWindowEndDate",
          "compute": {
            "operator": "ifElse",
            "condition": {
              "allOf": [
                { "field": "^changeEndDaysPriorToPurchaseDate", "notEmpty": true },
                { "anyOf": [
                  { "field": "purchaseDate", "notEmpty": true },
                  { "field": "periodEndDate", "notEmpty": true }
                ]}
              ]
            },
            "then": {
              "operator": "pipe",
              "steps": [
                { "operator": "dateOffset", "days": "^changeEndDaysPriorToPurchaseDate", "negate": true }
              ]
            },
            "else": { "operator": "field", "name": "changeWindowEndDate" }
          },
          "onlyIfDerived": true
        }
      ]
    }
  }
}
